import dayjs from "dayjs";

export const hexToRgb = (hex: string, opacity = 1): string | null => {
  // Remove the hash if it's present
  const cleanedHex = hex.replace(/^#/, "");

  // regualr expression to match pairs of two characters and convert them to decimal
  const match = cleanedHex.match(/.{1,2}/g);

  if (match === null) {
    // Invalid hex code
    return null;
  }

  const [red, green, blue] = match.map((value) => parseInt(value, 16));

  return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
};

export const truncateWithEllipsis = (str: string, maxLength: number): string  => {
  if (str.length > maxLength) {
    return str.slice(0, maxLength) + "...";
  }
  return str;
};

export const daysBtwTwoDates = (date1: Date, date2: Date) => {
  const dateModified1 = dayjs(date1);
  const dateModified2 = dayjs(date2);
  const difference = dateModified1.diff(dateModified2, "days");
  return Math.floor(Math.abs(difference));
};  

//This function takes numbers, and if its a decimal it rounds it to a certain number of decimal digits
export function roundDecimalNumber(num: number, decimalDigits: number): number {
  // Check if the number has decimal places
  if (num % 1 !== 0) {
    return parseFloat(num.toFixed(decimalDigits)); // Round to 2 decimal places
  }
  return num; // If no decimals, return the number as is
}
